// extracted by mini-css-extract-plugin
export default {"container":"QN-z","topReviewHeading":"RN-z","criticalReview":"SN-z","favorableReview":"TN-z","vsSeparator":"UN-z"};